import useValidation from "../../hooks/useValidation"
import { ChangeEvent, useEffect, useState } from "react"
import { StatusSignatureType } from "../../static/types/commonTypes/statusSignatureType"
import statusSigantureValidationSchema from "../../utils/validation/statusSignatureValidationSchema"
import FieldDescription from "../tools/FieldDescription"
import { transferTypes } from "../../static/types/objectType"
import { format, parse, isValid } from "date-fns";

import "react-datepicker/dist/react-datepicker.css";
import useAppContext from "../../hooks/useAppContext"
import { AppContextType } from "../../context/AppContext"

type statusSignatureProps = {
    checked: boolean,
    statusSignature: StatusSignatureType,
    changeStatusSignature: ( statusSignature: Partial<StatusSignatureType> ) => void,
    onValidationChange: ( isValid: boolean ) => void
}

export default function StatusSignature({
    checked,
    statusSignature,
    changeStatusSignature,
    onValidationChange
}: statusSignatureProps ) {

    
    const {
        draftFormData, setDraftFormData
    } = useAppContext() as AppContextType
    
    const stringifyDraft = ( data: any ) => { return JSON.stringify( data )}
    const parseDraft: any = () => { return draftFormData ? JSON.parse( draftFormData ) : {} }


    const { errors, isValid: isDataValid } = useValidation(statusSignature, statusSigantureValidationSchema);

    useEffect(() => {
        onValidationChange(isDataValid);

        const draft = parseDraft()
        const tempDraft = { ...draft, statusSignature }
        setDraftFormData( stringifyDraft( tempDraft ))
    }, [isDataValid, onValidationChange]);

    const [selectedDate, setSelectedDate] = useState<string>("");

    useEffect(() => {
        if (statusSignature.actDate) {
            const parsedDate = parse(statusSignature.actDate, "dd/MM/yyyy", new Date());
            setSelectedDate(isValid(parsedDate) ? format(parsedDate, "yyyy-MM-dd") : "");
        }
    }, [statusSignature]);

    const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputDate = e.target.value;
        const parsedDate = parse(inputDate, "yyyy-MM-dd", new Date());
        const formattedDate = isValid(parsedDate) ? format(parsedDate, "dd/MM/yyyy") : "";

        setSelectedDate(inputDate);
        changeStatusSignature({ actDate: formattedDate });
        
        const draft = parseDraft()
        const tempDraft = { ...draft, statusSignature }
        setDraftFormData( stringifyDraft( tempDraft ))
    };

    const openDatePicker = (id: string) => {
        const input = document.getElementById(id) as HTMLInputElement;
        input?.showPicker();
    };

    return (
        <div className="mb-3 row">
            <label htmlFor="actNature" className="col-sm-2 col-form-label">
                Nature de l'acte <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-10 mb-3">
                <select
                    className={`form-control ${checked && errors.actNature ? 'is-invalid' : ''}`}
                    id="actNature"
                    onChange={event => changeStatusSignature({ actNature: event.target.value })}
                    value={statusSignature.actNature}
                >
                    {transferTypes.map((option) => (
                        <option key={option} value={option}>
                            {option}
                        </option>
                    ))}
                </select>

                {checked && errors.actNature && <div className="invalid-feedback">{errors.actNature}</div>}
            </div>

            <label htmlFor="actDate" className="col-sm-2 col-form-label">
                Date de l'acte <strong className="text-danger">*</strong>
            </label>

            <div className="col-sm-10 mb-3">
                <input
                    className={`description-input form-control ${checked && errors.actDate ? 'is-invalid' : ''}`}
                    type="date"
                    id="actDate"
                    value={selectedDate}
                    onChange={handleDateChange}
                    onClick={() => openDatePicker("actDate")}
                    placeholder="JJ/MM/AAAA"
                />

                {checked && errors.actDate && <div className="invalid-feedback">{errors.actDate}</div>}
                <FieldDescription description="Date de création de la société, doit être identique à celle de la page de signature des statuts de la société." />
            </div>

            {statusSignature.actPlace && (
                <>
                    <label htmlFor="actPlace" className="col-sm-2 col-form-label">
                        Lieu de l'acte
                    </label>

                    <div className="col-sm-10 mb-3">
                        <input
                            className="form-control description-input"
                            type="text"
                            id="actPlace"
                            value={statusSignature.actPlace || ""}
                            onChange={event => changeStatusSignature({ actPlace: event.target.value })}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
